export const iconFontAwesomeSecurityShieldHalved = (
	<i className="fa-solid fa-shield-halved"></i>
);
